export var ToolbarOverrides = function (theme) {
    var _a, _b;
    return ({
        MuiToolbar: {
            regular: (_a = {
                    minHeight: '48px'
                },
                _a["".concat(theme.breakpoints.up('xs'), " and (orientation: landscape)")] = {
                    minHeight: undefined,
                },
                _a[theme.breakpoints.up('sm')] = {
                    minHeight: undefined,
                },
                _a[theme.breakpoints.up('md')] = {
                    minHeight: '64px',
                },
                _a),
            gutters: (_b = {
                    paddingLeft: '12px',
                    paddingRight: '12px'
                },
                _b[theme.breakpoints.up('sm')] = {
                    paddingLeft: '20px',
                    paddingRight: '20px',
                },
                _b[theme.breakpoints.up('md')] = {
                    paddingLeft: '30px',
                    paddingRight: '30px',
                },
                _b),
        },
    });
};
//# sourceMappingURL=Toolbar.overrides.js.map